import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import { useAuth } from '../auth/AuthProvider';
import { Icon } from './Icon';
import { useToast } from './Toast';

/**
 * خطّ الشركة المسلَّم للموظف.
 *
 * الشركة توزّع هواتفها وخطوطها على موظفيها، وكلٌّ يسجّل خطّه هنا — به
 * يتصل، وهو الظاهر للعميل، ويُلتقط على كل مكالمة في التقارير. مكانه
 * إعدادات الحساب لا صدر لوحة الاتصال: بيانٌ يُضبط مرةً لا زينةٌ دائمة.
 */
export function AgentLineField() {
  const { session } = useAuth();
  const user = session!.user;
  const toast = useToast();
  const queryClient = useQueryClient();
  const [value, setValue] = useState<string | null>(null);

  const presence = useQuery({
    queryKey: ['cc', 'presence'],
    queryFn: () => api<{ items: Array<Record<string, any>> }>('/callcenter/presence'),
  });
  const mine = presence.data?.items.find((p) => p.userId === user.id);
  const saved = (mine?.companyPhone as string | null) ?? '';
  const current = value ?? saved;

  const save = useMutation({
    mutationFn: (phone: string | null) =>
      api('/callcenter/agent-phone', { method: 'PATCH', body: { phone } }),
    onSuccess: () => {
      toast('حُفظ خطّك');
      void queryClient.invalidateQueries({ queryKey: ['cc', 'presence'] });
    },
    onError: (e) => toast(e instanceof Error ? e.message : 'تعذّر الحفظ'),
  });

  return (
    <label className="field">
      <span className="label">خطّ الشركة المسلَّم إليك</span>
      <div className="row" style={{ gap: 'var(--sp-2)' }}>
        <input
          className="input num"
          dir="ltr"
          placeholder="01xxxxxxxxx"
          value={current}
          onChange={(e) => setValue(e.target.value)}
          aria-label="خط الشركة"
        />
        <button
          className="btn"
          disabled={save.isPending || current.trim() === saved}
          onClick={() => save.mutate(current.trim() || null)}
        >
          <Icon name="phone" size={14} />
          حفظ
        </button>
      </div>
      <span className="tiny mute">
        به تتصل، وهو الظاهر للعميل، ويظهر في تقارير المكالمات.
      </span>
    </label>
  );
}
